import React from "react";
import OutletCard from "../../components/OutletCard/OutletCard";
import { Card } from "reactstrap";
import CategoryFilter from "../../components/CategoryFilter/CategoryFilter";
import { useCustomizeShop } from "./_hooks/useCustomizeShop";
import { CustomizeShopCategories } from "./CustomizeShop.constants";
import "./CustomizeShop.scss";
import Banners from "./components/Banners";
import HeaderFavicon from "./components/HeaderFavicon";
import Pages from "./components/Pages";
import Fonts from "./components/Fonts";
import Advanced from "./components/Advanced";

const CustomizeShop = () => {
  const {
    handleCategorySelect,
    state,
    uploadBanner,
    currentCategory,
    deleteBanner,
  } = useCustomizeShop();

  return (
    <OutletCard>
      <Card className="d-flex flex-column justify-content-between flex-row flex-wrap gap-3 bg-light customize-shop">
        <CategoryFilter
          categories={CustomizeShopCategories}
          onSelect={handleCategorySelect}
          currentCategory={currentCategory}
          iconAlignLeft={true}
        />
        {currentCategory === "Header & Favicon" && <HeaderFavicon />}
        {currentCategory === "Banners" && (
          <Banners
            banners={state?.banners}
            uploadBanner={uploadBanner}
            deleteBanner={deleteBanner}
          />
        )}
        {currentCategory === "Pages" && <Pages />}
        {currentCategory === "Fonts" && <Fonts />}
        {currentCategory === "Advanced" && <Advanced />}
      </Card>
    </OutletCard>
  );
};

export default CustomizeShop;
